module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAxNSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjk4NDkgMkwzLjE1NTc2IDExLjQxNjRMMTIuMjk3MiAyMC4wOTUzIiBzdHJva2U9IiM2ODY4NjgiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anniversary/back.svg
// module id = 0BP+
// module chunks = 0